// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__sD-bA","footerPlaceholder":"Footer_footerPlaceholder__NVXZd"};